import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";

import FooterLink from "./components/FooterLink";
import Button from "../../components/ui/Button";
import AuthContext from "../../context/AuthContext";
import FooterLogo from "../../assets/navbar/whiteLogo.png";
import FacebookIcon from "../../assets/Updated-imagery/facebookIcon.svg";
import InstaIcon from "../../assets/Updated-imagery/instagramIcon.svg";
import YoutubeIcon from "../../assets/Updated-imagery/youtubeIcon.svg";
import telegramIcon from "../../assets/Updated-imagery/telegramIcon.svg";
import tikTokIcon from "../../assets/Updated-imagery/tiktokIcon.svg";
import whatsappIcon from "../../assets/Updated-imagery/whatsapp.svg";

const Footer = ({ layout = "default" }) => {
    const [showBounce, setShowBounce] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setShowBounce(false), 1500);
        return () => clearTimeout(timer);
    }, []);
    return (
        <div className="footer bg-[#133053] py-20 clr-white flex-center-both flex-col space-y-6 w-full">
            {layout === "default" ? (
                <>
                    <div className="flex-center-both space-x-5 space-x-reverse">
                        <FooterLink
                            link="https://www.youtube.com/channel/UC-o4Nbu_f9wtSXaeXdhIVLg"
                            className={`bg-gradient-to-r from-rose-500 to-red-500 `}
                            icon={<Icon icon="ant-design:youtube-filled" />}
                        />
                        <FooterLink
                            link="https://www.facebook.com/mrwaleedmohsen"
                            className={`bg-gradient-to-r from-cyan-500 to-blue-500 `}
                            icon={<Icon icon="fa6-brands:facebook" />}
                        />
                        <FooterLink
                            link="https://whatsapp.com/channel/0029VaIebV1KbYMOD7zyCC0Q"
                            className={`bg-gradient-to-r from-green-600 to-green-300 `}
                            icon={<Icon icon="ri:whatsapp-line" />}
                        />
                        <FooterLink
                            link="https://t.me/waleedmohsen3820"
                            className={`bg-gradient-to-r from-cyan-600 to-cyan-300 `}
                            icon={<Icon icon="line-md:telegram" />}
                        />
                    </div>
                    <div className="h-1 bg-slate-800 rounded-md w-2/3 sm:w-1/3 "></div>
                    <div className="flex-center-both space-x-5 space-x-reverse px-5">
                        <span className="font-h2 ">
                            <Icon icon="emojione-v1:beating-heart" />
                        </span>
                        <span className="text-slate-200 text-center shrink">
                            تم صنع هذه المنصة بهدف تهيئة الطالب لـ كامل جوانب الثانوية العامة و ما
                            بعدها
                        </span>
                        <span className="font-h2">
                            <Icon icon="emojione-v1:beating-heart" />
                        </span>
                    </div>{" "}
                </>
            ) : layout === "t_type" ? (
                <>
                    <div className=" flex w-full pb-10 justify-between items-center flex-col-reverse md:flex-row gap-14">
                        <div className="flex-1 w-full flex-center-both flex-col md:flex-row gap-10 ">
                            <div className="basis-full md:basis-1/2 flex flex-col gap-7 items-center justify-center">
                                <img
                                    src={FooterLogo}
                                    alt="FooterLogo#waleed"
                                    className=" max-w-[180px] md:max-w-[560px]"
                                />
                                <p className="text-center font-Messiri text-xl font-bold text-white">
                                    منصة أستاذي للغة العربية
                                    <br />
                                    متخصصة للطلاب الساعين للتفوق
                                </p>
                            </div>
                            <div className="basis-full md:basis-1/2 flex-center-both w-full flex-col gap-3">
                                <p>
                                    <span className="text-lemon-200">
                                        متنساش تتابعنا وتتواصل معانا من خلال :
                                    </span>
                                </p>
                                <div className="flex gap-10 justify-center w-full">
                                    <FooterLink
                                        link="https://www.youtube.com/channel/UC-o4Nbu_f9wtSXaeXdhIVLg"
                                        scale={false}
                                        icon={
                                            <img
                                                src={YoutubeIcon}
                                                alt="Youtube"
                                                className="w-12 h-auto"
                                            />
                                        }
                                    />
                                    <FooterLink
                                        link="https://www.facebook.com/groups/3412891062344088/?ref=share&mibextid=NSMWBT"
                                        scale={false}
                                        icon={
                                            <img
                                                src={FacebookIcon}
                                                alt="Face"
                                                className="w-12 h-auto"
                                            />
                                        }
                                    />
                                    <FooterLink
                                        link="https://t.me/waleedmohsen3820"
                                        scale={false}
                                        icon={
                                            <img
                                                src={telegramIcon}
                                                alt="telegram"
                                                className="w-12 h-auto"
                                            />
                                        }
                                    />
                                    <FooterLink
                                        link="https://whatsapp.com/channel/0029VbAUPFx7YSdCGa7UZ12p"
                                        scale={false}
                                        icon={
                                            <img
                                                src={whatsappIcon}
                                                alt="whatsapp"
                                                className="w-12 h-auto"
                                            />
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                ""
            )}
            <div className="en text-center font-com space-x-2 opacity-60 px-5 flex flex-wrap flex-center-both">
                <span className="font-w-bold space-x-1">
                    <span className="text-purple-600">&#60;</span>
                    <span className="text-purple-300">Developed By</span>
                    <span className="text-purple-600">&#62;</span>
                </span>
                <span>
                    <a
                        href="https://www.facebook.com/Om4rS4Ieh/"
                        className="bg-slate-700 hover-shadow smooth px-2 py-2 rounded-md"
                    >
                        Omar
                    </a>
                    <span>,</span>
                    <a
                        href="https://www.facebook.com/emad.sharf.16"
                        className="bg-slate-700 hover-shadow smooth px-3 py-1 rounded-md"
                    >
                        Emad
                    </a>
                </span>
                <span className="font-w-bold space-x-1">
                    <span className="text-purple-600">&#60;</span>
                    <span className="text-purple-300">
                        All Copy Rights Reserved @{new Date().getFullYear()}
                    </span>
                    <span className="text-purple-600">&#62;</span>
                </span>
            </div>
            <div className="flex-center-both flex-col">
                <div className="en">Powered by حلول رقميه ذكيه</div>
                <div className="">ت.ض. </div>
                <div className="en">١٤٤-٧٩٦-٦٨٦</div>
            </div>

            {/* <div className="text"></div> */}
            <div className="fixed bottom-5 left-5 z-50 flex items-center gap-2 group">
                <div
                    className={`px-3 py-2 rounded-lg text-sm font-cairo shadow-lg
                                ${showBounce ? "animate-bounce" : ""}
                                bg-black/70 text-white dark:bg-white/80 smooth dark:text-gray-800
                                group-hover:opacity-0
                                `}
                >
                    تواصل مع الدعم الفني هنا
                </div>

                <div
                    className={`text-2xl text-cyan-500 rotate-[45deg] ${
                        showBounce ? "animate-bounce" : ""
                    } group-hover:opacity-0`}
                >
                    ↑
                </div>

                <FooterLink
                    link="https://t.me/+201284032109"
                    className={`bg-gradient-to-r from-cyan-500 to-blue-500 ${
                        showBounce ? "animate-bounce" : ""
                    }`}
                    icon={<Icon icon="mingcute:telegram-fill" className="text-white text-2xl" />}
                />
            </div>
        </div>
    );
};

export default Footer;
